<template>
  <div class="documentsPage">
    <div class="nav">
      <div class="navItem pointer" v-for="(item, index) in menuList" :key="index" @click="gotoRoute(item.href)">
        <div class="label" :class="{act: item.href === $store.state.currentRoute}">{{item.label}}</div>
      </div>
      <div class="logout pointer" @click="logout" v-if="isLogin">{{$t('lang.setting.logout')}}</div>
    </div>
    <div class="docContainer">
      <router-view/>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import {LogUtils} from '@/utils'
export default {
  name: 'Documents',
  data () {
    return {
      menuList: [
        {
          label: this.$t('lang.menu.Terms'),
          href: 'Documents/Terms'
        },
        {
          label: this.$t('lang.menu.Privacy'),
          href: 'Documents/Privacy'
        },
        {
          label: this.$t('lang.menu.Responsible'),
          href: 'Documents/Responsible'
        },
        {
          label: this.$t('lang.menu.News'),
          href: 'Documents/News'
        },
        {
          label: this.$t('lang.menu.AboutUs'),
          href: 'Documents/About'
        }
      ],
      isLogin: !!localStorage.getItem('userInfo')
    }
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute'
    }),
    gotoRoute (href) {
      if (this.$store.state.currentRoute === href) return
      this.setCurrentRoute(href)
      this.$router.push('/' + href)
    },
    logout () {
      LogUtils.fbListener('Logout')
      localStorage.removeItem('userInfo')
      this.$router.go(0)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setCurrentRoute('Documents/' + vm.$route.name)
    })
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width:769px) {
  .documentsPage {
    display:flex;
    padding: 10px 150px 100px 165px;
    .nav {
      position: relative;
      width: 180px;
      height: 588px;
      margin-right: 35px;
      padding-top: 38px;
      background: #202020;
      border-radius: 6px 0 0 6px;
      .caption {
        margin: 38px 0;
        font-size: 24px;
        line-height: 28px;
        color: #F6D9AA;
      }
      .navItem {
        margin-bottom: 30px;
        padding-left: 32px;
        img {
          width: 24px;
          margin-right: 18px;
        }
        .label {
          font-size: 18px;
          color: #686868;
        }
        .act {
          color: #F6D9AA;
        }
      }
      .logout {
        position: absolute;
        bottom: 20px;
        width: 100%;
        color: #F6D9AA;
        text-align: center;
      }
    }
    .docContainer {
      position: relative;
      flex: 1;
      height: 588px;
      padding: 38px 120px;
      background: #202020;
      border-radius: 0 6px 6px 0;
      width: calc(100% - 155px);
    }
  }
}
@media screen and (max-width: 768px) and (min-width:481px) {
  .documentsPage {
    display:flex;
    padding: 10px 40px 100px 40px;
    .nav {
      position: relative;
      width: 180px;
      height: 588px;
      margin-right: 35px;
      padding-top: 38px;
      background: #202020;
      border-radius: 6px 0 0 6px;
      .caption {
        margin: 38px 0;
        font-size: 24px;
        line-height: 28px;
        color: #F6D9AA;
      }
      .navItem {
        margin-bottom: 30px;
        padding-left: 32px;
        img {
          width: 24px;
          margin-right: 18px;
        }
        .label {
          font-size: 18px;
          color: #686868;
        }
        .act {
          color: #F6D9AA;
        }
      }
      .logout {
        position: absolute;
        bottom: 20px;
        width: 100%;
        color: #F6D9AA;
        text-align: center;
      }
    }
    .docContainer {
      position: relative;
      flex: 1;
      height: 588px;
      padding: 38px 30px;
      background: #202020;
      border-radius: 0 6px 6px 0;
      width: calc(100% - 155px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Documents/index.vue